<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <el-card class="card">
          <div class="main">
            <div class="govenments_content">
              <div class="govenments_content_title">
                <div class="govenments_content_title_text">{{ $t('home.governments') }}</div>
                <div class="govenments_content_title_line"></div>

              </div>


              <div class="govenments_content_logo">
                <div class="swiper" id="swiper1">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in imageList" :key="index" @click="openUrl(item.plugUrl)">
                      <img :src="item.plugImage" class="bookImg"/>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'zh'">{{ item.plugName }}</div>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'en'">{{ item.engName }}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <div class="govenments_content">
              <div class="govenments_content_title">
                <div class="govenments_content_title_text">{{ $t('home.internationalOrganization') }}</div>
                <div class="govenments_content_title_line"></div>

              </div>


              <div class="govenments_content_logo">
                <div class="swiper" id="swiper2">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in imageList2" :key="index" @click="openUrl(item.plugUrl)">
                      <img :src="item.plugImage" class="bookImg"/>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'zh'">{{ item.plugName }}</div>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'en'">{{ item.engName }}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <div class="govenments_content">
              <div class="govenments_content_title">
                <div class="govenments_content_title_text">{{ $t('home.academicInstitution') }}</div>
                <div class="govenments_content_title_line"></div>

              </div>


              <div class="govenments_content_logo">
                <div class="swiper" id="swiper3">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in imageList3" :key="index" @click="openUrl(item.plugUrl)">
                      <img :src="item.plugImage" class="bookImg"/>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'zh'">{{ item.plugName }}</div>
                      <div class="govenments_content_logo_name" v-if="$i18n.locale == 'en'">{{ item.engName }}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <!-- <div class="govenments_content">
                 <div class="govenments_content_title">
                     <div class="govenments_content_title_text">GOVENMNTS</div>
                     <div class="govenments_content_title_line"></div>

                 </div>
                 <div class="govenments_content_logo">
                     <el-carousel :interval="4000" type="card" height="300px" :autoplay="false" indicator-position="none" arrow="always">
                         <el-carousel-item v-for="item in imageList" :key="item" style="height: 300px;width: 33%;margin-left: 8%;">
                             <el-image  :src="item.url" style="width: 150px;height: 150px;margin-left:6.5vh"></el-image>
                     <div class="govenments_content_logo_name">{{item.name}}</div>
                         </el-carousel-item>
                     </el-carousel>
                 </div>

            </div> -->

          </div>

        </el-card>

      </div>
    </div>
    <!-- <shareDialog ref="shareDialog"></shareDialog> -->
  </div>
</template>

<script>
import Swiper from 'swiper';
import {getplugList} from "../../api/resouces"

export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      iconUrl: require('@/components/contact/imgs/icon.png'),
      datalists: [
        {name: "澜沧江-湄公河合作", enName: "Lancang-Mekong Cooperation"},
        {name: "中华人民共和国公安部", enName: "Ministry of Pubic Security of the People's Republic of China"},
        {name: "柬埔寨王国内政部", enName: "Ministry of National Defense of Laos"},
        {name: "老挝国防部", enName: "Ministry of Public Security of Laos"},
        {name: "老挝公安部", enName: "Ministry of Interior ofthe kingdom of Cambodia"},
        {name: "柬埔寨国家禁毒委员会", enName: "National Authority of Combating Drugs"},
        {name: "泰国皇家警察", enName: "Royal Thai Police"},
        {name: "越南公安部", enName: "Myanmar Police Force"},
        {name: "缅甸警察部队", enName: "Ministry of PublicSecurity of SocialistRepublic of Vietnam"},
        {name: "东盟警察组织", enName: "Police Forces of ASEAN"}
      ],
      imageList: [],
      imageList2: [],
      imageList3: [],
      imageListEn: [
        {
          url: require('@/components/partners/imgs/logo3.png'),
          name: 'Ministry of Public Security of the PRC'
        },
        {
          url: require('@/components/partners/imgs/logo4.png'),
          name: 'Ministry of PublicSecurity of Laos'
        },
        {
          url: require('@/components/partners/imgs/logo5.png'),
          name: 'Ministry of Public Security of SRV'
        },
        {
          url: require('@/components/partners/imgs/logo1.png'),
          name: 'Ministry of National Defense of Laos'
        },
        {
          url: require('@/components/partners/imgs/logo2.png'),
          name: 'Ministry of Interior of the kingdom of Cambodia'
        },

      ],
      imageListZh: [
        {
          url: require('@/components/partners/imgs/logo3.png'),
          name: '澜沧江-湄公河合作'

        },
        {
          url: require('@/components/partners/imgs/logo3.png'),
          name: '中华人民共和国公安部'
        },
        {
          url: require('@/components/partners/imgs/logo4.png'),
          name: '老挝公安部'
        },
        {
          url: require('@/components/partners/imgs/logo5.png'),
          name: '越南公安部'
        },
        {
          url: require('@/components/partners/imgs/logo1.png'),
          name: '老挝国防部'
        },
        {
          url: require('@/components/partners/imgs/logo2.png'),
          name: '柬埔寨国王内政部'
        },

      ],
      imageList2En: [
        {
          url: require('@/components/partners/imgs/interpol.png'),
          name: 'International Criminal Police Organization'
        },
        {
          url: require('@/components/partners/imgs/UNODC.png'),
          name: 'The United Nations Office on Drugs and Crime'
        },
        {
          url: require('@/components/partners/imgs/中国东盟中心.jpg'),
          name: 'ASEAN-CHINA CENTRE'
        },
        {
          url: require('@/components/partners/imgs/上海合作组织.png'),
          name: 'Shanghai Cooperation Organization'
        },

      ],
      imageList2Zh: [
        {
          url: require('@/components/partners/imgs/INTERPOLs.png'),
          name: '国际警察组织'
        },
        {
          url: require('@/components/partners/imgs/UNODC.png'),
          name: '联合国毒品和犯罪问题办公室'
        },
        {
          url: require('@/components/partners/imgs/中国东盟中心.jpg'),
          name: '中国东盟中心'
        },
        {
          url: require('@/components/partners/imgs/上海合作组织.png'),
          name: '上海合作组织'
        },

      ],
      imageList3En: [
        {
          url: require('@/components/partners/imgs/中国人民警察大学.jpg'),
          name: 'China People’s Police University'
        },
        {
          url: require('@/components/partners/imgs/浙江警察学院.jpeg'),
          name: 'Zhejiang Police College'
        },
        {
          url: require('@/components/partners/imgs/云南警官学院.png'),
          name: 'Yunnan Police College'
        },
        {
          url: require('@/components/partners/imgs/西北政法大学.jpg'),
          name: 'Northwest University of Political Science and Law'
        },
        {
          url: require('@/components/partners/imgs/郑州警察学院.jpg'),
          name: 'Zhengzhou Police University'
        },
      ],
      imageList3Zh: [
        {
          url: require('@/components/partners/imgs/中国人民警察大学.jpg'),
          name: '中国人民警察大学'
        },
        {
          url: require('@/components/partners/imgs/浙江警察学院.jpeg'),
          name: '浙江警察学院'
        },
        {
          url: require('@/components/partners/imgs/云南警官学院.png'),
          name: '云南警官学院'
        },
        {
          url: require('@/components/partners/imgs/西北政法大学.jpg'),
          name: '西北政法大学'
        },
        {
          url: require('@/components/partners/imgs/郑州警察学院.jpg'),
          name: '郑州警察学院'
        },
      ],
    }
  },
  mounted() {
    // if (this.$i18n.locale == 'zh') {
    //   // this.imageList = this.imageListZh
    //   this.imageList2 = this.imageList2Zh
    //   this.imageList3 = this.imageList3Zh
    // } else {
    //   // this.imageList = this.imageListEn
    //   this.imageList2 = this.imageList2En
    //   this.imageList3 = this.imageList3En
    // }
    getplugList({classification:"0"}).then(res => {
      this.imageList = []
      this.imageList = res.data
     
      setTimeout(() => {
        new Swiper("#swiper1", {
          //开启这个参数来计算每个slide的progress，Swiper的progress无需设置即开启
          watchSlidesProgress: true,
          //设置slider容器能够同时显示的slides数量
          slidesPerView: 3,
          //active图片居中
          centeredSlides: true,
          //开启loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
          loop: true,
          //   //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)。
          loopedSlides: 4,
          //轮播设置
          autoplay: {
            //点击后仍能自动开始轮播
            disableOnInteraction: false,
          },
          autoHeight: true,
          //pre, next按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //使用分页器导航。分页器可使用小圆点样式（默认）、分式样式或进度条样式。
          pagination: {
            el: ".swiper-pagination",
            //clickable :true,
          },
          //不允许拖动
          allowTouchMove: false,
          effect: 'coverflow',
          coverflowEffect: {
            rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: "-19%", //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 50, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            modifier: 5,
            slideShadows: false, //开启slide阴影。默认 true。
          },

        });
        // new Swiper("#swiper2", {
        //   //开启这个参数来计算每个slide的progress，Swiper的progress无需设置即开启
        //   watchSlidesProgress: true,
        //   //设置slider容器能够同时显示的slides数量
        //   slidesPerView: 3,
        //   //active图片居中
        //   centeredSlides: true,
        //   //开启loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
        //   loop: true,
        //   //   //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)。
        //   //   loopedSlides: 5,
        //   //轮播设置
        //   autoplay: {
        //     //点击后仍能自动开始轮播
        //     disableOnInteraction: false,
        //   },
        //   //pre, next按钮
        //   navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        //   },
        //   //使用分页器导航。分页器可使用小圆点样式（默认）、分式样式或进度条样式。
        //   pagination: {
        //     el: ".swiper-pagination",
        //     //clickable :true,
        //   },
        //   //不允许拖动
        //   allowTouchMove: false,
        //   effect: 'coverflow',
        //   coverflowEffect: {
        //     rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        //     stretch: "-19%", //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
        //     depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        //     modifier: 5,
        //     slideShadows: false, //开启slide阴影。默认 true。
        //   },

        // });
        // new Swiper("#swiper3", {
        //   //开启这个参数来计算每个slide的progress，Swiper的progress无需设置即开启
        //   watchSlidesProgress: true,
        //   //设置slider容器能够同时显示的slides数量
        //   slidesPerView: 3,
        //   //active图片居中
        //   centeredSlides: true,
        //   //开启loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
        //   loop: true,
        //   //   //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)。
        //   //   loopedSlides: 5,
        //   //轮播设置
        //   autoplay: {
        //     //点击后仍能自动开始轮播
        //     disableOnInteraction: false,
        //   },
        //   //pre, next按钮
        //   navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        //   },
        //   //使用分页器导航。分页器可使用小圆点样式（默认）、分式样式或进度条样式。
        //   pagination: {
        //     el: ".swiper-pagination",
        //     //clickable :true,
        //   },
        //   //不允许拖动
        //   allowTouchMove: false,
        //   effect: 'coverflow',
        //   coverflowEffect: {
        //     rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        //     stretch: "-19%", //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
        //     depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        //     modifier: 5,
        //     slideShadows: false, //开启slide阴影。默认 true。
        //   },

        // });
      }, 500);

    })
    getplugList({classification:"2"}).then(res => {
      this.imageList2 = []
      this.imageList2 = res.data
     
      setTimeout(() => {
        new Swiper("#swiper2", {
          //开启这个参数来计算每个slide的progress，Swiper的progress无需设置即开启
          watchSlidesProgress: true,
          //设置slider容器能够同时显示的slides数量
          slidesPerView: 3,
          //active图片居中
          centeredSlides: true,
          //开启loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
          loop: true,
          //   //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)。
          //   loopedSlides: 5,
          //轮播设置
          autoplay: {
            //点击后仍能自动开始轮播
            disableOnInteraction: false,
          },
          //pre, next按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //使用分页器导航。分页器可使用小圆点样式（默认）、分式样式或进度条样式。
          pagination: {
            el: ".swiper-pagination",
            //clickable :true,
          },
          //不允许拖动
          allowTouchMove: false,
          effect: 'coverflow',
          coverflowEffect: {
            rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: "-19%", //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            modifier: 5,
            slideShadows: false, //开启slide阴影。默认 true。
          },

        });
      }, 500);

    })
    getplugList({classification:"1"}).then(res => {
      this.imageList3 = []
      this.imageList3 = res.data
     
      setTimeout(() => {
        new Swiper("#swiper3", {
          //开启这个参数来计算每个slide的progress，Swiper的progress无需设置即开启
          watchSlidesProgress: true,
          //设置slider容器能够同时显示的slides数量
          slidesPerView: 3,
          //active图片居中
          centeredSlides: true,
          //开启loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
          loop: true,
          //   //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)。
          //   loopedSlides: 5,
          //轮播设置
          autoplay: {
            //点击后仍能自动开始轮播
            disableOnInteraction: false,
          },
          //pre, next按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //使用分页器导航。分页器可使用小圆点样式（默认）、分式样式或进度条样式。
          pagination: {
            el: ".swiper-pagination",
            //clickable :true,
          },
          //不允许拖动
          allowTouchMove: false,
          effect: 'coverflow',
          coverflowEffect: {
            rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: "-19%", //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            modifier: 5,
            slideShadows: false, //开启slide阴影。默认 true。
          },

        });
      }, 500);

    })
  },
  methods: {
    openUrl(url){
          window.open(url)
      },
    shareClick() {
      this.$refs.shareDialog.open('Repost to Facebook', {})

    },
    turnLeft() {
      // console.log("this.imageList",this.imageList[0])

      let obj = {}
      let list = JSON.parse(JSON.stringify(this.imageList))
      obj = JSON.parse(JSON.stringify(list[0]))

      list.splice(0, 1);
      list.push(obj)
      this.imageList = list
      // console.log("this.imageList",this.imageList)
    },
  }
}
</script>

<style scoped lang="less">
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    /* height:100vh; */
    overflow: hidden;

  }

  .containerbody {
    width: 100%;
    /* height:100%; */
    background-color: rgb(249, 249, 249);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;


  }

  .content {
    width: 60%;
    /* height:100%; */
    margin: 0 auto;

  }

  .main {
    width: 80%;

    /* height:100%; */
    margin: 50px auto;
    /* // display: flex;
                // align-items: center; */


  }

  .govenments_content {
    width: 100%;
    height: 400px;
  }

  .govenments_content_title {
    width: 100%;
    margin: 0 auto;
  }

  .govenments_content_title_text {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 28px;
    font-family: 'fzxbsjt';
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    line-height: 42px;
  }

  .govenments_content_title_line {
    background-color: rgba(45, 82, 208, 1);
    border-radius: 8px;
    width: 20%;
    height: 4px;
    margin: 0 auto;
  }

  .logo_normal {
    width: 100px;
    height: 100px;
  }

  .logo_active {
    width: 200px;
    height: 200px;
  }

  .govenments_content_logo {
    /* width: 100%; */
    /* height: 300px; */
    margin: 40px 0;
    overflow: hidden;
  }

  .item_container {
    width: 100%;
    text-align: center;


  }

  .apparatus_logo {
    font-size: 16px;
    margin-right: 10px;
    vertical-align: text-bottom;
  }

  .apparatus_name {
    color: #333;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    line-height: 19px;
  }

  .apparatus_img {
    padding: 7% 0.5%;
    /* background: url("../../assets/images/meteorologicalObservation/默认-bg.png") no-repeat; */
    /* background-size: 100% 100%; */
    /* // background-size: contain; */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;


  }

  img {
    width: 85%;
    height: 80%;
  }


  /* .swiper-slide {
    width: 20%;
  } */
  .govenments_content_logo_name {
    width: 100%;
    /* height: 30px; */
    /* margin:0 auto; */
    line-height: 20px;
    text-align: center;
  }

  .card {
    height: 100%;
    margin-bottom: 12px;

  }

  .swiper {
    /* width: 100%; */
    margin-bottom: 20px;


  }

  .swiper-slide {
    /* width: 20% !important; */
    /* width:auto; */
    /* height: 120px; */
    width: 17vh;
    font-size: 14px;
    text-align: center;
    line-height: 80px;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
  }

  .bookImg {
    width: 16vh;
    height: 16vh;
    border-radius: 8px;
    margin: 0 auto;
  }

  .swiper-button-prev {
    height: 20px;
    width: 20px;
  }

  .swiper:hover .swiper-button-prev {
    display: block;
  }

  .swiper:hover .swiper-button-next {
    display: block;
  }

  .swiper-wrapper {
    float: left;
    /* width: 100%; */
    /* height: 100%; */
    margin: 0 auto;
  }
}

@media only screen and (max-width: 800px){
  .container {
    width: 100%;
    /* height:100vh; */
    overflow: hidden;

  }

  .containerbody {
    width: 100%;
    /* height:100%; */
    background-color: rgb(249, 249, 249);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 0;


  }

  .content {
    width: 100%;
    /* height:100%; */
    margin: 0 auto;

  }

  .main {
    width: 90%;
    margin: 0px auto;
  }

  .govenments_content {
    width: 100%;
    height: 350px;
  }

  .govenments_content_title {
    width: 100%;
    margin: 0 auto;
  }

  .govenments_content_title_text {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    font-family: 'fzxbsjt';
    font-weight: 700;
    text-align: center;
    //white-space: nowrap;
    line-height: 42px;
  }

  .govenments_content_title_line {
    background-color: rgba(45, 82, 208, 1);
    border-radius: 8px;
    width: 20%;
    height: 4px;
    margin: 0 auto;
  }

  .logo_normal {
    width: 100px;
    height: 100px;
  }

  .logo_active {
    width: 100px;
    height: 100px;
  }

  .govenments_content_logo {
    /* width: 100%; */
    /* height: 300px; */
    margin: 40px 0;
    overflow: hidden;
  }

  .item_container {
    width: 100%;
    text-align: center;


  }

  .apparatus_logo {
    font-size: 16px;
    margin-right: 10px;
    vertical-align: text-bottom;
  }

  .apparatus_name {
    color: #333;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    line-height: 19px;
  }

  .apparatus_img {
    padding: 7% 0.5%;
    /* background: url("../../assets/images/meteorologicalObservation/默认-bg.png") no-repeat; */
    /* background-size: 100% 100%; */
    /* // background-size: contain; */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;


  }

  img {
    width: 85%;
    height: 80%;
  }


  /* .swiper-slide {
    width: 20%;
  } */
  .govenments_content_logo_name {
    width: 95%;
    /* height: 30px; */
    /* margin:0 auto; */
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }

  .card {
    height: 100%;
    margin-bottom: 12px;

  }

  .swiper {
    /* width: 100%; */
    margin-bottom: 20px;


  }

  .swiper-slide {
    /* width: 20% !important; */
    /* width:auto; */
    /* height: 120px; */
    width: 17vh;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
    border-radius: 8px;
    position: relative;
  }

  .bookImg {
    width: 97%;
    height: auto;
    border-radius: 8px;
    margin: 0 auto;
  }

  .swiper-button-prev {
    height: 20px;
    width: 20px;
  }

  .swiper:hover .swiper-button-prev {
    display: block;
  }

  .swiper:hover .swiper-button-next {
    display: block;
  }

  .swiper-wrapper {
    float: left;
    /* width: 100%; */
    /* height: 100%; */
    margin: 0 auto;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/partners/index.vue